import ajax from './ajax';

export type FlagCategory = 'incorrect_answer' | 'typo' | 'unclear' | 'technical_issue' | 'inappropriate';
export type FlagStatus = 'pending' | 'under_review' | 'resolved' | 'rejected';

export interface QuestionFlag {
    _id: string;
    questionId: any;
    examId?: any;
    attemptId?: string;
    flaggedBy: any;
    category: FlagCategory;
    description: string;
    status: FlagStatus;
    resolution?: string;
    resolvedBy?: string;
    resolvedAt?: string;
    createdAt: string;
}

export const FLAG_CATEGORY_LABELS: Record<FlagCategory, string> = {
    incorrect_answer: 'Incorrect answer',
    typo: 'Typo / grammar',
    unclear: 'Unclear question',
    technical_issue: 'Technical issue',
    inappropriate: 'Inappropriate content',
};

class QuestionFlagService {
    async createFlag(data: {
        questionId: string;
        category: FlagCategory;
        description: string;
        examId?: string;
        attemptId?: string;
    }): Promise<QuestionFlag> {
        return ajax.post('/api/question-flags', data);
    }

    async listFlags(
        params: { status?: FlagStatus; questionId?: string; page?: number; limit?: number } = {},
    ): Promise<{ flags: QuestionFlag[]; total: number; page: number; limit: number }> {
        const queryParams = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
            if (value !== undefined && value !== null) queryParams.append(key, String(value));
        });
        const query = queryParams.toString();
        return ajax.get(`/api/question-flags${query ? `?${query}` : ''}`);
    }

    async updateFlag(id: string, status: FlagStatus, resolution?: string): Promise<QuestionFlag> {
        return ajax.put(`/api/question-flags/${id}`, { status, resolution });
    }
}

export default new QuestionFlagService();
